import { Navigate, Route, Routes } from "react-router-dom"
import { DashboardLayout } from "../../pages/private-section/dashboard/dashboard-layout/DashboardLayout"
import { PrivateRoute } from "../private-route"
import { DashboardHome, FormCreateTravaConsumoCliente, FormCreateTravaConsumoPerfil, FormCreateTravaConsumoUsuario, FormUpdateTravaConsumoCliente, FormUpdateTravaConsumoPerfil, FormUpdateTravaConsumoUsuario, ListaTravaConsumo, RelatoriosReceitas, RelatoriosAnaliticos, RelatorioSinteticoQuantitativo, RelatoriosAcessos } from "../../pages/private-section/dashboard"
import { ListaClientes } from "../../pages/private-section/dashboard/crud-clientes"
import { ListaDePerfis } from "../../pages/private-section/dashboard/crud-perfil"
import { ListaUsuarios } from "../../pages/private-section/dashboard/crud-usuarios"
import { AuthSectionLayout, LoginPage } from "../../pages/auth-section"
import { FormCreateCliente } from "../../pages/private-section/dashboard/crud-clientes/form-cliente"
import { FormEditCliente } from "../../pages/private-section/dashboard/crud-clientes/form-cliente/FormEditCliente"
import { FormVincularProdutoCliente } from "../../pages/private-section/dashboard/crud-clientes/form-vincular-produto-cliente"
import { FormListaIp } from "../../pages/private-section/dashboard/crud-clientes/form-lista-ip"
import { FormCreatePerfil } from "../../pages/private-section/dashboard/crud-perfil/FormCreatePerfil"
import { FormEditPerfil } from "../../pages/private-section/dashboard/crud-perfil/FormEditPerfil"
import { FormVincularProdutoPerfil } from "../../pages/private-section/dashboard/crud-perfil/form-vincular-produto-perfil"
import { FormCreateUsuario, FormEditUsuario } from "../../pages/private-section/dashboard/crud-usuarios/form-usuario"
import { RequestNewPasswordForm, PasswordRecoveryLayout, ValidateCodeForm, CreateNewPasswordForm, PasswordRecoveryIndex } from "../../pages/auth-section/password-recovery"
import { ModalContainer } from "../../modal-container"
import { FormCreateIPPermitido, FormUpdateIPPermitido, ListaIPPermitido } from "../../pages/private-section/dashboard/crud-ip-permitido"
import { useEffect } from "react"

const RedirectToVelesApp = () => {
  useEffect(() => {
    window.location.href = process.env.REACT_APP_VELES_APP_URL_LOGIN!
  }, [])
  return null
}

export const MainRouter = () => {
  return (
    <>
      <ModalContainer />
      <Routes>
          <Route path="/" element={<Navigate to="/modulos" />} />
          <Route path="modulos" element={<RedirectToVelesApp />} />
          <Route path="dashboard" element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }>
            <Route path="" element={
              <PrivateRoute>
                <DashboardHome />
              </PrivateRoute>
            } />
            <Route path="cadastro/cliente">
              <Route path="" element={
                <PrivateRoute>
                  <ListaClientes />
                </PrivateRoute>
              } />
              <Route path="create" element={
                <PrivateRoute>
                  <FormCreateCliente />
                </PrivateRoute>
              } />
              <Route path="edit" >
                <Route path="" element={
                  <PrivateRoute>
                    <FormEditCliente />
                  </PrivateRoute>
                } />
                <Route path="vincular-produto" element={
                  <PrivateRoute>
                    <FormVincularProdutoCliente />
                  </PrivateRoute>
                } />
                <Route path="vincular-ip" element={
                  <PrivateRoute>
                    <FormListaIp />
                  </PrivateRoute>
                } />
              </Route>
            </Route>
            <Route path="cadastro/perfil">
              <Route path="" element={
                <PrivateRoute>
                  <ListaDePerfis />
                </PrivateRoute>
              } />
              <Route path="create" element={
                <PrivateRoute>
                  <FormCreatePerfil />
                </PrivateRoute>
              } />
              <Route path="edit" >
                <Route path="" element={
                  <PrivateRoute>
                    <FormEditPerfil />
                  </PrivateRoute>
                } />
                <Route path="vincular-produto" element={
                  <PrivateRoute>
                    <FormVincularProdutoPerfil />
                  </PrivateRoute>
                } />

              </Route>
            </Route>
            <Route path="cadastro/usuario">
              <Route path="" element={
                <PrivateRoute>
                  <ListaUsuarios />
                </PrivateRoute>
              } />
              <Route path="create" element={
                <PrivateRoute>
                  <FormCreateUsuario />
                </PrivateRoute>
              } />
              <Route path="edit" element={
                <PrivateRoute>
                  <FormEditUsuario />
                </PrivateRoute>
              } />
            </Route>
            <Route path="trava/consumo">
              <Route path="" element={
                <PrivateRoute>
                  <ListaTravaConsumo />
                </PrivateRoute>
              } />
              <Route path="cliente">
                <Route path="novo" element={
                  <PrivateRoute>
                    <FormCreateTravaConsumoCliente />
                  </PrivateRoute>
                } />
                <Route path="atualizar" element={
                  <PrivateRoute>
                    <FormUpdateTravaConsumoCliente />
                  </PrivateRoute>
                } />
              </Route>
              <Route path="usuario">
                <Route path="novo" element={
                  <PrivateRoute>
                    <FormCreateTravaConsumoUsuario />
                  </PrivateRoute>
                } />
                <Route path="atualizar" element={
                  <PrivateRoute>
                    <FormUpdateTravaConsumoUsuario />
                  </PrivateRoute>
                } />
              </Route>
              <Route path="perfil">
                <Route path="novo" element={
                  <PrivateRoute>
                    <FormCreateTravaConsumoPerfil />
                  </PrivateRoute>
                } />
                <Route path="atualizar" element={
                  <PrivateRoute>
                    <FormUpdateTravaConsumoPerfil />
                  </PrivateRoute>
                } />
              </Route>
            </Route>

            <Route path="relatorios/sintetico-quantitativo" element={
              <PrivateRoute>
                <RelatorioSinteticoQuantitativo />
              </PrivateRoute>
            } />
            
            <Route path="relatorios/receitas" element={
              <PrivateRoute>
                <RelatoriosReceitas />
              </PrivateRoute>
            } />
            
            <Route path="relatorios/analiticos" element={
              <PrivateRoute>
                <RelatoriosAnaliticos />
              </PrivateRoute>
            } />
            
            <Route path="relatorios/acessos" element={
              <PrivateRoute>
                <RelatoriosAcessos />
              </PrivateRoute>
            } />

            <Route path="trava/ip-permitido">
              <Route path="" element={
                <PrivateRoute>
                  <ListaIPPermitido />
                </PrivateRoute>
              } />
              <Route path="novo" element={
                <PrivateRoute>
                  <FormCreateIPPermitido />
                </PrivateRoute>
              } />
              <Route path="atualizar" element={
                <PrivateRoute>
                  <FormUpdateIPPermitido />
                </PrivateRoute>
              } />
            </Route>
          </Route>
          <Route path="auth/login" element={<LoginPage />} />
          <Route path="auth" element={<AuthSectionLayout />}>
            <Route path="password-recovery" element={<PasswordRecoveryLayout />}>
              <Route index element={<PasswordRecoveryIndex />} />
              <Route path="request-new-password" element={<RequestNewPasswordForm />} />
              <Route path="validate-code" element={<ValidateCodeForm />} />
              <Route path="create-new-password" element={<CreateNewPasswordForm />} />
            </Route>
          </Route>
        </Routes>
    </>
  )
}